import { CalendarIcon } from 'components/icons/Icons';
import { InputText } from 'components/forms/InputText';
import React from 'react';
import { PossibleAnswer, Question } from '../../types/interfaces';

interface SimpleInputQuestionProps {
  question: Question;
  currentAnswers: PossibleAnswer[];
  onAnswer: (key: string, answer: PossibleAnswer[]) => void;
  placeholder?: string;
  type?: 'text' | 'number' | 'email' | 'date';
  min?: number | string | undefined;
  max?: number | string | undefined;
}

const SimpleInputQuestion: React.FC<SimpleInputQuestionProps> = ({
  question,
  currentAnswers,
  onAnswer,
  placeholder,
  type = 'text',
  min,
  max,
}) => {
  const getCurrentValue = (): string => {
    if (!currentAnswers || currentAnswers.length === 0) return '';
    const answer = currentAnswers[0];
    return typeof answer === 'string' || typeof answer === 'number' ? String(answer) : '';
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const answer = type === 'number' ? (value ? Number(value) : '') : value;
    onAnswer(question.key, answer ? [answer] : []);
  };

  return (
    <div className="flex items-center justify-between w-full">
      <label className="flex gap-4 text-base text-zinc-800 flex-1">
        <CalendarIcon className='text-primary w-6' />
        {question.label}
      </label>

      <div className="ml-4">
        <InputText
          type={type}
          min={min}
          max={max}
          value={getCurrentValue()}
          onChange={handleInputChange}
          placeholder={placeholder}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
        />
      </div>
    </div>
  );
};

export default SimpleInputQuestion;
